import { addHash, createHashPath } from "src/utils/hash";
import { SECTION_IDS } from "src/page-components/home/constants";
import { PATHNAMES } from "src/constants/routes";
import { ILink } from "src/@types";

export const SCROLL_NAV_MENU_ITEMS = [
  {
    id: "1",
    label: "Про нас",
    href: createHashPath(SECTION_IDS.ABOUT_US),
    selector: addHash(SECTION_IDS.ABOUT_US),
  },
  {
    id: "2",
    label: "Переваги",
    href: createHashPath(SECTION_IDS.ADVANTAGES),
    selector: addHash(SECTION_IDS.ADVANTAGES),
  },
  {
    id: "3",
    label: "Пакети",
    href: createHashPath(SECTION_IDS.SERVICE_PACKAGES),
    selector: addHash(SECTION_IDS.SERVICE_PACKAGES),
  },
  {
    id: "4",
    label: "Послуги",
    href: createHashPath(SECTION_IDS.SERVICES),
    selector: addHash(SECTION_IDS.SERVICES),
  },

  {
    id: "5",
    label: "Наша команда",
    href: createHashPath(SECTION_IDS.TEAM),
    selector: addHash(SECTION_IDS.TEAM),
  },
  {
    id: "6",
    label: "Зв'язок",
    href: createHashPath(SECTION_IDS.CONTACT_US),
    selector: addHash(SECTION_IDS.CONTACT_US),
  },
];

export const LINK_NAV_MENU_ITEMS: ILink[] = [
  {
    id: "6",
    label: "Калькулятор",
    href: PATHNAMES.CALCULATOR,
  },
  {
    id: "7",
    label: "Блог",
    href: PATHNAMES.BLOG,
  },
];
